import debounce from "lodash.debounce"

import elementary from './vendor/elementary'

window.addEventListener('load', elementary, false);
window.addEventListener('resize', debounce(handleWindowResize, 100), false);

function handleWindowResize() {

	// Remove data attribute on elements created by elementary before reloading it
	for (const el of document.querySelectorAll('[data-minwidth]')) {
		el.removeAttribute('data-minwidth');
	}
	elementary();
}

// Add class to html when user is tabbing, so we can add focus styles
function handleFirstTab(e) {

    if (e.keyCode === 9) { // the "I am a keyboard user" key
        document.documentElement.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
	}
}

window.addEventListener('keydown', handleFirstTab);

// const Validation = require('bluegg-validation');
// new Validation({
// 	errorClass: 'form-field--error',
// 	fieldContainer: '.form-field'
// });

// import fitvids from "fitvids"
// fitvids('.figure--video .figure__media');

import cookieNotice from './modules/cookie-notice'
cookieNotice()

import scrollAnimate from './modules/scroll-animate'
scrollAnimate()

import reframe from 'reframe.js'
// reframe('.bg-media iframe, .figure--video .figure__media')
reframe('.figure--video .figure__media iframe')

import bgMediaVideo from './modules/bg-media-video'
bgMediaVideo()

import nav from './modules/nav'
nav()

import primaryNav from './modules/primary-nav'
primaryNav()

import pubNav from './modules/pub-nav'
pubNav()

import modals from './modules/modals'
modals()

import search from './modules/search'
search()

import Forms from './modules/forms'
Forms()

import LocationRequester from './modules/location-requester'
LocationRequester()

import Filters from './modules/filters'
Filters()

import Finder from './modules/finder'
Finder()

import Maps from './modules/maps'
Maps()

const tabsComponentBp = 720;

import Tabs from "./modules/tabs"
Tabs()

import TabsList from "./modules/tabs-list"
TabsList()

import TabPanels from "./modules/tab-panels"
TabPanels()

import TabsComponent from "./modules/tabs-component"
TabsComponent(tabsComponentBp)

import Accordions from "./modules/accordions"
Accordions()

import Carousels from "./modules/carousels"
Carousels()

import BookingMenuTriggers from "./modules/booking-menu-triggers"
BookingMenuTriggers()


// const liveResIframe = document.querySelector('[name="_fez_"]');
// if (liveResIframe !== null) {
// 	console.log('sending');
	
// 	liveResIframe.contentWindow.postMessage('Test from parent', 'http://localhost:3000');
// }

// window.addEventListener("message", receiveMessage, false);

// function receiveMessage(event) {
// 	console.log(event);
// }